var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Endpoints"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(_vm.pagination)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _c("b", [_vm._v("Filters:")]),
                      ]),
                      _vm._v(" "),
                      _vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-up")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-down")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showFilters
                    ? _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs11: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Id",
                                              rules: [_vm.rules.numeric],
                                            },
                                            model: {
                                              value: _vm.id,
                                              callback: function ($$v) {
                                                _vm.id = $$v
                                              },
                                              expression: "id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.organizations,
                                              label: "Organization",
                                              "item-text": "text",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.orgId,
                                              callback: function ($$v) {
                                                _vm.orgId = $$v
                                              },
                                              expression: "orgId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Deleted",
                                              items: _vm.deletedItems,
                                            },
                                            model: {
                                              value: _vm.deleted,
                                              callback: function ($$v) {
                                                _vm.deleted = $$v
                                              },
                                              expression: "deleted",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Name" },
                                            model: {
                                              value: _vm.name,
                                              callback: function ($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Description" },
                                            model: {
                                              value: _vm.description,
                                              callback: function ($$v) {
                                                _vm.description = $$v
                                              },
                                              expression: "description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Alias" },
                                            model: {
                                              value: _vm.alias,
                                              callback: function ($$v) {
                                                _vm.alias = $$v
                                              },
                                              expression: "alias",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Host" },
                                            model: {
                                              value: _vm.host,
                                              callback: function ($$v) {
                                                _vm.host = $$v
                                              },
                                              expression: "host",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Model" },
                                            model: {
                                              value: _vm.model,
                                              callback: function ($$v) {
                                                _vm.model = $$v
                                              },
                                              expression: "model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Firmware" },
                                            model: {
                                              value: _vm.firmware,
                                              callback: function ($$v) {
                                                _vm.firmware = $$v
                                              },
                                              expression: "firmware",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Directory Number",
                                            },
                                            model: {
                                              value: _vm.dn,
                                              callback: function ($$v) {
                                                _vm.dn = $$v
                                              },
                                              expression: "dn",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      onsubmit: "false",
                                      disabled: !_vm.valid,
                                    },
                                    on: { click: _vm.applyFilters },
                                  },
                                  [_vm._v("Apply")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { onsubmit: "false" },
                                    on: { click: _vm.resetFilters },
                                  },
                                  [_vm._v("Reset")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.endpoints.content,
                              loading: _vm.loading,
                              headers: _vm.headers,
                              options: _vm.pagination,
                              "footer-props": {
                                "items-per-page-options": [
                                  5, 10, 15, 20, 50, 100,
                                ],
                              },
                              "server-items-length": _vm.totalItems,
                            },
                            on: {
                              "update:options": function ($event) {
                                _vm.pagination = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.name",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: { to: "" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.editItem(item)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.updatedDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(item.updatedDate)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.deleted",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(item.deleted ? "yes" : "no")
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              height: "0px",
                                              width: "0px",
                                              "padding-right": "2px",
                                            },
                                            attrs: { text: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editItem(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm.isSUPro
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-pencil")]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-info-circle")]
                                                ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.showEditEndpointDialog,
                callback: function ($$v) {
                  _vm.showEditEndpointDialog = $$v
                },
                expression: "showEditEndpointDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Endpoint"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.validSystem,
                            callback: function ($$v) {
                              _vm.validSystem = $$v
                            },
                            expression: "validSystem",
                          },
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "subheading",
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                               Id: " +
                                          _vm._s(_vm.editedItem.id) +
                                          " OrgId: " +
                                          _vm._s(_vm.editedItem.org.id) +
                                          " (" +
                                          _vm._s(_vm.editedItem.org.name) +
                                          ")\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [_vm.rules.required],
                                          label: "Name",
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Description" },
                                        model: {
                                          value: _vm.editedItem.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [_vm.rules.required],
                                          label: "Host Address",
                                        },
                                        model: {
                                          value: _vm.editedItem.hostAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "hostAddress",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.hostAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "External ID" },
                                        model: {
                                          value: _vm.editedItem.externalId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "externalId",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.externalId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Firmware" },
                                        model: {
                                          value: _vm.editedItem.firmware,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "firmware",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.firmware",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "DN" },
                                        model: {
                                          value: _vm.editedItem.dn,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editedItem, "dn", $$v)
                                          },
                                          expression: "editedItem.dn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Username" },
                                        model: {
                                          value: _vm.editedItem.login,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "login",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.login",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Password",
                                          type: "password",
                                        },
                                        model: {
                                          value: _vm.editedItem.password,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.password",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { sm6: "", md6: "" } }),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs9: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Aliases" },
                                        model: {
                                          value: _vm.editedItem.aliases,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "aliases",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.aliases",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Deleted" },
                                        model: {
                                          value: _vm.editedItem.deleted,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "deleted",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.deleted",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: { label: "Misc Data" },
                                        model: {
                                          value: _vm.editedItem.miscDataJson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "miscDataJson",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.miscDataJson",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "blue darken-1" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.isSUPro ? "Cancel" : "Close"))]
                      ),
                      _vm._v(" "),
                      _vm.isSUPro
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                color: "blue darken-1",
                                disabled: !_vm.validSystem,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.save.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Save")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }